import * as React from "react";
import {Route} from "react-router-dom";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import {Navbar, Nav, NavItem} from "react-bootstrap";

import Dashboard from "./Dashboard";
import OrderGrid from "./OrderGrid";
import OrderDetail from "./OrderDetail";
import DiscountsGrid from "./Discounts";
import TicketAdmin from "./TicketAdmin";
import {ApplicationState} from "../../reducers";
import {SecurityState} from "../../reducers/security";
import {ensureToken, getToken} from "../../actions/token";
import Login from "./Login";
import {loadLoggedInUser, SecurityAction, logout} from "../../actions/security";

const ComingSoon: React.SFC = () => <div>Coming Soon!</div>;

interface AdminProps extends SecurityState, RouteComponentProps<any> {
    loadLoggedInUser: () => Promise<SecurityAction>;
    logout: () => Promise<SecurityAction>;
}

class AdminShell extends React.Component<AdminProps> {

    componentWillUpdate(nextProps: Readonly<AdminProps>, nextState: Readonly<{}>, nextContext: any): void {
        this.checkAutoLogin();
    }

    componentDidMount() {
        this.checkAutoLogin();
    }

    checkAutoLogin() {
        ensureToken().then(token => {
            if (token && token.validated && token.userId && !this.props.user &&
                !this.props.loading && !this.props.loadLoggedInFailed) {
                this.props.loadLoggedInUser();
            }
        });
    }

    logout(event: React.MouseEvent<any>) {
        event.preventDefault();
        this.props.logout().then(() => this.props.history.push("/admin"));
    }

    render(): JSX.Element {
        const token = getToken();
        const loggedIn = this.props.user && token && token.validated;

        if (!loggedIn) {
            return <Login/>;
        }

        const go = (path: string) => () => this.props.history.push(path);
        const links = [
            ["/admin", "Dashboard"],
            ["/admin/orders", "Orders"],
            ["/admin/tickets", "Tickets"],
            ["/admin/discounts", "Discounts"]
        ];
        const navItems = links.map((link, index) =>
            <NavItem key={link[0]} eventKey={index} onClick={go(link[0])}>{link[1]}</NavItem>);
        const activeKey = links.findIndex((link: any, index: number) => {
            return this.props.location.pathname.indexOf(link[0]) > -1 && index > 0;
        });

        const {match} = this.props;
        return (
            <div>
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Brand>
                            <img src="/wdwtickets/img/logo.png"/>
                        </Navbar.Brand>
                    </Navbar.Header>
                    <Nav activeKey={activeKey > -1 ? activeKey : 0}>
                        {navItems}
                    </Nav>
                    <Navbar.Text>
                        <a href="#" onClick={this.logout.bind(this)}>Logout</a>
                    </Navbar.Text>
                </Navbar>
                <Route exact path={`${match.path}/`} component={Dashboard}/>
                <Route exact path={`${match.path}/orders`} component={OrderGrid}/>
                <Route exact path={`${match.path}/orders/:id`} component={OrderDetail}/>
                <Route exact path={`${match.path}/tickets`} component={TicketAdmin}/>
                <Route exact path={`${match.path}/discounts`} component={DiscountsGrid}/>
            </div>
        );
    }
}

const connected = connect(
    (state: ApplicationState) => ({...state.security}),
    {loadLoggedInUser, logout}
)(AdminShell);

export default withRouter<any>(connected);



// WEBPACK FOOTER //
// ./src/components/admin/index.tsx